import FJImageManipulationColorizer from '../view/FJImageManipulationColorizer';
import FJLocalStore from '../../../../store/FJLocalStore';
import { useSelector, useDispatch } from 'react-redux';
import {
    setSliceSwitchPhotoColorizeAction,
    setSliceSelectedColorNameAction,
} from '../../../../redux/slices/FJSliceImageManipulation';
import PropTypes from 'prop-types';

const FJImageManipulationColorizerContainer = ({ disabled }) => {
    const dispatch = useDispatch();
    const switchPhotoColorize = useSelector(state => state.imageManipulation.switchPhotoColorize);
    const selectedColorName = useSelector(state => state.imageManipulation.selectedColorName);

    const onSwitchPhotoColorize = value => {
        dispatch(setSliceSwitchPhotoColorizeAction(value));
    };

    const onColorizerChange = name => {
        dispatch(setSliceSelectedColorNameAction(name));
    };

    return (
        <FJImageManipulationColorizer
            text={FJLocalStore._('ai-photo-colorizer')}
            active={switchPhotoColorize}
            onChange={onSwitchPhotoColorize}
            onColorizerChange={onColorizerChange}
            selectedColorName={selectedColorName}
            disabled={disabled}
            style={{ width: '435px' }}
        />
    );
};

FJImageManipulationColorizerContainer.propTypes = {
    disabled: PropTypes.bool,
};

export default FJImageManipulationColorizerContainer;
